export default class PlayerFactory {
  createPlayer() {
    throw new Error('.createPlayer must be defined on PlayerFactory instance');
  }
}
